import { render } from "./RegistrationModal.vue?vue&type=template&id=31b92a82&scoped=true"
import script from "./RegistrationModal.vue?vue&type=script&lang=js"
export * from "./RegistrationModal.vue?vue&type=script&lang=js"

import "./RegistrationModal.vue?vue&type=style&index=0&id=31b92a82&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31b92a82"]])

export default __exports__